<mat-chip
  (click)="$event.stopPropagation()"
  (focus)="$event.stopPropagation()"
  class="mat-chip"
  [disabled]="loading || selectedDataChipProperties?.properties?.disabled"
  [removable]="
    (isChipOptional() ||
      isChipPreselected() ||
      isChipChiningParams() ||
      isChipDefault()) &&
    !loading
  "
  (removed)="remove(selectedData)"
  >
  <div class="chip-content" style="display: flex; align-items: center">
    <label class="has-float-label">
      @if (!multi) {
        <mat-select
          disableOptionCentering
          [matTooltip]="selectedOption?.key || selectedData?.name || ''"
          #select
          class="chip-input"
          [style.width.px]="getInputWidth(selectedItemLength, label)"
          (click)="$event.stopPropagation()"
          (focus)="$event.stopPropagation()"
        [style.vertical-align]="
          selectedDataChipProperties?.value || this.inputFocusOn
            ? 'sub'
            : 'baseline'
        "
          (keydown)="$event.stopImmediatePropagation()"
          [formControl]="selectItems"
          [value]="selectItems.value"
        attr.data-testid="cis_select_single_{{
          selectedData?.name?.toLowerCase()?.replace(' ', '_')
        }}"
          hideSingleSelectionIndicator="true"
          >
          @for (option of options | async; track option) {
            <mat-option
          attr.data-testid="cis_select_single_{{
            selectedData?.name?.toLowerCase()?.replace(' ', '_')
          }}_option_{{ option.key.toLowerCase().replace(' ', '_') }}"
              [value]="option.value"
              >
              {{ option.key }}
            </mat-option>
          }
        </mat-select>
      }

      @if (multi) {
        <mat-select
          disableOptionCentering
          multi
        [matTooltip]="
          (selectedOption?.key && value?.length > 1
            ? selectedOption?.key + suffixDependsOnSelectedItems
            : value?.length === 1
            ? selectedOption?.key
            : selectedData?.name) ?? ''
        "
          class="chip-input"
          [style.width.px]="getInputWidth(selectedItemLength, label)"
          (click)="$event.stopPropagation()"
          (focus)="$event.stopPropagation()"
          (keydown)="$event.stopImmediatePropagation()"
        [style.vertical-align]="
          selectedDataChipProperties?.value || this.inputFocusOn
            ? 'sub'
            : 'baseline'
        "
          [formControl]="selectItems"
          [value]="selectItems.value"
        attr.data-testid="cis_select_multi_{{
          selectedData?.name?.toLowerCase()?.replace(' ', '_')
        }}"
          hideSingleSelectionIndicator="true"
          >
          <mat-select-trigger>
            {{ selectItems.value ? this.selectedOption?.key : '' }}
            @if ((selectItems.value?.length ?? 0) > 1) {
              <span>
                {{ suffixDependsOnSelectedItems }}
              </span>
            }
          </mat-select-trigger>
          @for (option of options | async; track option) {
            <mat-option
          attr.data-testid="cis_select_multi_{{
            selectedData?.name?.toLowerCase()?.replace(' ', '_')
          }}_option_{{ option.key.toLowerCase().replace(' ', '_') }}"
              [value]="option.value"
              >
              {{ option.key }}
            </mat-option>
          }
        </mat-select>
      }
      <div #label class="label" [ngClass]="selectItems.value ? 'selected' : ''">
        {{ selectedData?.name ?? '' | translate }}
      </div>
    </label>

    @if (
      isChipOptional() ||
      isChipPreselected() ||
      isChipChiningParams() ||
      isChipDefault()
      ) {
      <mat-icon
        matChipRemove
        [style.cursor]="loading ? 'context-menu' : 'pointer'"
        style="vertical-align: text-top"
      attr.data-testid="cis_select_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}_btn_cancel"
        >cancel</mat-icon
        >
      }
      @if (isChipMandatory()) {
        <mat-icon
          style="vertical-align: middle; cursor: default"
      attr.data-testid="cis_select_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}_icon_mandatory"
          >push_pin</mat-icon
          >
        }
        @if (isChipLock()) {
          <mat-icon
            style="vertical-align: text-top; cursor: default"
      attr.data-testid="cis_select_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}_icon_locked"
            >lock</mat-icon
            >
          }
        </div>
      </mat-chip>
